<template>
	<div class="personHome">
		<!-- 左侧产品列表 -->
		<div class="psLeftContent">
			<!-- 表单 -->
			<div class="form bd10 p3">
				<div class="sTitle d-flex a-center j-sb">
					 <h3 class="font20">{{$t('adminMenu.password')}}</h3>
				</div>
				<dl>
					<dd class="d-flex f-colu">
						<div class="label font-medium">{{$t('findPassword.newPassword')}}</div>
						<div class="enter">
							<input type="password" v-model="formData.password" class="input font-light" :placeholder="$t('findPassword.newPassword')">
						</div>
						<div class="passwordLevel d-flex" v-if="formData.password" :class="passwordLevel">
							<div class="lv d-flex"><i></i><i></i><i></i></div>
							<div class="lt"><span>弱</span><span>中</span><span>强</span></div>
						</div>
					</dd>
					<dd class="d-flex f-colu">
						<div class="label font-medium">{{$t('admin.confirmNewPassword')}}</div>
						<div class="enter">
							<input type="password" v-model="formData.confirmPassword" class="input font-light" :placeholder="$t('admin.confirmNewPassword')">
						</div>
					</dd>
					<dd class="d-flex f-colu">
						<div class="label font-medium">{{$t('admin.emailCode')}}</div>
						<div class="enter d-flex code">
							<input type="text" v-model="formData.code" class="input font-light" :placeholder="$t('commom.codePlaceholder')">
							<button class="fmBtn pointer font-light" @click="getCode">{{codeText}}</button>
						</div>
					</dd>
				</dl>
				
			</div>
			<div class="submit">
				<button class="fmBtn pointer" @click="checkVerify">{{$t('admin.save')}}</button>
			</div>
		</div>
		<!-- 弹窗提示 -->
		<popup v-show="popupHandle">
			<div class="slot d-flex f-colu j-center a-center line-md">
				<img src="@/assets/Icons/error.png" alt="">
				{{message}}
			</div>
		</popup>
		<verify :show="showVerify" @success="handleVerify"></verify>
	</div>
</template>

<script>
// vuex
import { mapMutations } from 'vuex'
export default {
  name: 'ChangePassword',
  components: {
    
  },
  data() {
    return {
		// 表单
		formData: {
			email: '', // 邮箱
			code: '', // 验证码
			password: '', // 密码
			confirmPassword: '', // 确认密码
		},
		codeNumber: 60, // 获取验证码读秒
		message: '', // 提示
		popupHandle: false, // 控制提示弹窗是否显示
		sendStatus: true, // 验证码状态
		sendTimer: null, // 验证码定时器
		codeText: this.$t('commom.sendCode'), // 发送按钮文字
		passwordLevel:'',
		showVerify:false
	}
  },
  
  created() {
	  this.formData.email = this.$store.state.member.email;
  },
  watch:{
	'formData.password':function(val) {
		this.passwordLevel='l'+this.checkPasswordStrength(val);
	}
  },
  methods: {
	checkVerify(){
		let that = this;
		// 对密码进行验证
		if (!this.formData.password.trim() || !this.formData.confirmPassword.trim()) {
			this.message = this.$t('admin.passwordPlaceholder');
			this.popupHandle = true;
			return;
		}
		if (this.formData.password.trim().length<8) {
			this.message = this.$t('commom.passwordLengthWram');
			this.popupHandle = true;
			return;
		}
		if(this.formData.password.trim() === this.formData.confirmPassword.trim()) {}else{
				this.message = this.$t('commom.passwordNot');
				this.popupHandle = true;
				return;
			}
			// 对验证码进行验证
			if (!this.formData.code.trim()) {
			this.message = this.$t('commom.codePlaceholder');
			this.popupHandle = true;
			return;
		};
		that.showVerify=true;
	  },
	  handleVerify(){
		var that=this;
		that.showVerify=false;
		that.submitForm();
	  },
	checkPasswordStrength(password) {
		let strength = 1;
		// 判断密码是否包含大小写字母和数字，且长度大于等于8位
		if (/[a-z]/.test(password) && /[A-Z]/.test(password) && /\d/.test(password) && password.length >= 8) {
			strength = 3;
		} else if (password.length >= 8||(/[a-z]/.test(password) && /[A-Z]/.test(password) && /\d/.test(password))) {
			strength = 2;
		}
		return strength;
	},
	  // vuex
	  ...mapMutations(['changeState']),
	  
	  // 获取验证码
	  getCode() {
	  		  let that = this;
	  		  // 验证密码
	  		  // 对密码进行验证
	  		  if (!this.formData.password.trim() || !this.formData.confirmPassword.trim()) {
	  		    this.message = this.$t('admin.passwordPlaceholder');
	  		    this.popupHandle = true;
	  		    return;
	  		  }
	  		  if(this.formData.password.trim() === this.formData.confirmPassword.trim()) {}else{
				  this.message = this.$t('commom.passwordNot');
				  this.popupHandle = true;
				  return;
	  		  }
	  		  if(this.sendStatus) {
	  			  this.sendStatus = false;
	  			  this.$axios.get(`verifyMember/sendEmailCode?email=${this.formData.email}&type=password`)
	  			  .then(res => {
	  				  this.$message({
	  					message: this.$t('commom.sendSuccess'),
	  					type: "success"
	  				  });
	  			  })
	  			  .catch(err => {});
	  			  this.sendTimer = setInterval(() => {
	  				that.codeNumber--;
	  				if (that.codeNumber <= 0) {
	  				  that.codeNumber = 60;
	  				  that.codeText = this.$t('commom.sendCode');
	  				  that.sendStatus = true;
	  				  clearInterval(that.sendTimer);
	  				} else {
	  				  that.codeText = that.codeNumber + "s";
	  				}
	  			  }, 1000);
	  		  }
	  },
	  
	  // 提交修改
	  submitForm() {
	  		  let that = this;
	  		  
	  		  this.$axios({
	  			  method: 'post',
	  			  url: 'verifyMember/retrievePwd',
	  			  headers: {'Content-Type':'multipart/form-data'},
	  			  data: this.formData
	  		  }).then(res => {
				  // 清除Token
				  localStorage.removeItem("Authorization");
				  // 清除存储用户信息
				  localStorage.removeItem("member");
				  // 清除登录
				  localStorage.removeItem("isLogin");
				  //
				  localStorage.removeItem("isUpdatePassword");
				  // 修改store
				  this.changeState({
				  	member: {
						sexual: '',
						name: ''
					},
				  	isLogin: ''
				  });
	  			  this.$message({
	  				message: this.$t('admin.reLogin'),
	  				type: 'success'
	  			  });
	  			  // 1s后跳转登录
	  			  setTimeout(()=>{
	  				this.$router.push('/login');
	  			  }, 1000);
	  		  })
	  		  .catch(err => {});
	  }
  }
}
</script>

<style lang="less" scoped>
	.personHome{
		.psLeftContent{
			width: 100%;
			.submit{
				margin-top: .3rem;
				button{
					width: 1.2rem;
				}
			}
			.form{
				
				dl{
					max-width: 530px;
					dd{
						.label{
							margin-bottom: .1rem;
						}
						&:not(:last-child) {
							margin-bottom: .3rem;
						}
						.fmBtn{
							width: 1.1rem;
						}
						.input,.fmBtn{
							border-radius: 0;
						}
						.code .input{
							width: calc(100% - 1.1rem);
						}
						.item{
							width: 48%;
						}
					}
				}
			}
		}
		@media (max-width: 640px) {
			padding: .2rem;
		}
	}
</style>
